import { Link } from 'react-router-dom';

const courses = [
  {
    title: "Swim Instructor Certification",
    description: "Learn to teach swimmers of all ages with confidence and become a certified instructor.",
    path: "/programs/swim-instructor"
  },
  {
    title: "Lifesaving Instructor",
    description: "Train to deliver Bronze awards and First Aid. A leadership role in aquatic education.",
    path: "/programs/lifesaving-instructor"
  }
];

const Instructor = () => (
  <div className="bg-white py-24 px-6 text-gray-900">
    <div className="max-w-5xl mx-auto">
      <h1 className="text-4xl font-bold text-blue-800 text-center mb-12">
        Instructor & Advanced Courses
      </h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
        {courses.map((course, idx) => (
          <div key={idx} className="bg-blue-50 p-6 rounded-xl shadow hover:shadow-md transition">
            <h3 className="text-2xl font-semibold text-blue-900 mb-2">{course.title}</h3>
            <p className="text-sm text-gray-700 mb-4">{course.description}</p>
            <Link to={course.path}>
              <button className="bg-blue-700 text-white px-4 py-2 text-sm rounded-md hover:bg-blue-800 transition">
                See Schedule
              </button>
            </Link>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default Instructor;
